import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const REPORT_ROUTES: RouteObject[] = [
  {
    path: 'reports',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'total-sales',
        lazy: async () => {
          const TotalSalesPage = lazy(
            () => import('@/pages/reports/TotalSalesPage.tsx')
          )
          return { element: <TotalSalesPage /> }
        }
      },
      {
        path: 'sales-by-branch',
        lazy: async () => {
          const SalesByBranchPage = lazy(
            () => import('@/pages/reports/SalesByBranchPage.tsx')
          )
          return { element: <SalesByBranchPage /> }
        }
      },
      {
        path: 'sales-by-ally',
        lazy: async () => {
          const SalesByAllyPage = lazy(
            () => import('@/pages/reports/SalesByAllyPage.tsx')
          )
          return { element: <SalesByAllyPage /> }
        }
      },
      {
        path: 'automatic-payments',
        lazy: async () => {
          const AutomaticPaymentsPage = lazy(
            () => import('@/pages/reports/AutomaticPaymentsPage.tsx')
          )
          return { element: <AutomaticPaymentsPage /> }
        }
      },
      {
        path: 'apple-devices-overdue',
        lazy: async () => {
          const AppleDevicesOverduePage = lazy(
            () => import('@/pages/reports/AppleDevicesOverduePage.tsx')
          )
          return { element: <AppleDevicesOverduePage /> }
        }
      },
      {
        path: 'overdue-quotas-list',
        lazy: async () => {
          const OverdueQuotasListPage = lazy(
            () => import('@/pages/reports/OverdueQuotasListPage.tsx')
          )
          return { element: <OverdueQuotasListPage /> }
        }
      },
      {
        path: 'ally-overdue-devices',
        lazy: async () => {
          const AllyOverdueDevicesPage = lazy(
            () => import('@/pages/reports/AllyOverdueDevicesPage.tsx')
          )
          return { element: <AllyOverdueDevicesPage /> }
        }
      },
      {
        path: 'approved-payments-by-employees',
        lazy: async () => {
          const ApprovedPaymentsByEmployeesPage = lazy(
            () => import('@/pages/reports/ApprovedPaymentsByEmployeesPage.tsx')
          )
          return { element: <ApprovedPaymentsByEmployeesPage /> }
        }
      },
      {
        path: 'approved-payments-to-ally',
        lazy: async () => {
          const PaymentsApprovedToAllyPage = lazy(
            () => import('@/pages/reports/PaymentsApprovedToAllyPage.tsx')
          )
          return { element: <PaymentsApprovedToAllyPage /> }
        }
      },
      {
        path: 'recharge-by-ally',
        lazy: async () => {
          const RechargeByAllyPage = lazy(
            () => import('@/pages/reports/RechargeByAllyPage.tsx')
          )
          return { element: <RechargeByAllyPage /> }
        }
      },
      {
        path: 'marketplace-ally-pending-products',
        lazy: async () => {
          const MarketplaceAllyPendingProductsPage = lazy(
            () =>
              import('@/pages/reports/MarketplaceAllyPendingProductsPage.tsx')
          )
          return { element: <MarketplaceAllyPendingProductsPage /> }
        }
      },
      {
        path: 'referral-codes',
        lazy: async () => {
          const ReferralCodesPage = lazy(
            () => import('@/pages/reports/ReferralCodesPage.tsx')
          )
          return { element: <ReferralCodesPage /> }
        }
      },
      {
        path: 'branch-offices',
        lazy: async () => {
          const BranchOfficePage = lazy(
            () => import('@/pages/reports/BranchOfficePage.tsx')
          )
          return { element: <BranchOfficePage /> }
        }
      },
      {
        path: 'movistar-club',
        lazy: async () => {
          const MovistarClubPage = lazy(
            () => import('@/pages/reports/MovistarClubPage.tsx')
          )
          return { element: <MovistarClubPage /> }
        }
      },
      {
        path: 'preassigned-credit-summary',
        lazy: async () => {
          const PreassignedCreditSummaryPage = lazy(
            () => import('@/pages/reports/PreassignedCreditSummaryPage.tsx')
          )
          return { element: <PreassignedCreditSummaryPage /> }
        }
      },
      {
        path: 'credit-refinancing',
        lazy: async () => {
          const CreditRefinancingPage = lazy(
            () => import('@/pages/reports/CreditRefinancingPage.tsx')
          )
          return { element: <CreditRefinancingPage /> }
        }
      },
      {
        path: 'weppa-plus-clients',
        lazy: async () => {
          const WeppaPlusClientsPage = lazy(
            () => import('@/pages/reports/WeppaPlusClientsPage.tsx')
          )
          return { element: <WeppaPlusClientsPage /> }
        }
      },
      {
        path: 'zone-u',
        lazy: async () => {
          const ZoneUPage = lazy(() => import('@/pages/reports/ZoneUPage.tsx'))
          return { element: <ZoneUPage /> }
        }
      },
      {
        path: 'cashout',
        lazy: async () => {
          const CashOutPage = lazy(
            () => import('@/pages/reports/CashOutPage.tsx')
          )
          return { element: <CashOutPage /> }
        }
      },
      {
        path: 'geolocation',
        lazy: async () => {
          const GeolocationPage = lazy(
            () => import('@/pages/reports/GeolocationPage.tsx')
          )
          return { element: <GeolocationPage /> }
        }
      },
      {
        path: 'assigned-motorcycles',
        lazy: async () => {
          const AssignedMotorcyclesPage = lazy(
            () => import('@/pages/reports/AssignedMotorcyclesPage.tsx')
          )
          return { element: <AssignedMotorcyclesPage /> }
        }
      },
      {
        path: 'quotes-collection',
        lazy: async () => {
          const QuotesCollectionPage = lazy(
            () => import('@/pages/reports/QuotesCollectionPage.tsx')
          )
          return { element: <QuotesCollectionPage /> }
        }
      },
      {
        path: 'cash-top-ups',
        lazy: async () => {
          const CashTopUpsPage = lazy(
            () => import('@/pages/reports/CashTopUpsPage.tsx')
          )
          return { element: <CashTopUpsPage /> }
        }
      }
    ]
  }
]

export default REPORT_ROUTES
